import type { Job } from "@domain/CRM/job";
import { isJobSampled } from "@domain/CRM/job";
import type { ShiftDropoff } from "@domain/CRM/dropoff";
import type { Shift } from "../types/Shift";

/**
 * MC-parity "Total scheduled" count: across the given shifts, the number of loaded UNSAMPLED
 * committed jobs plus the number of dropoff stops (MC sums every item in its shift buckets —
 * scheduled jobs + Shift Dropoffs). Sampled jobs are excluded — MC's schedule job view drops
 * them, and our shift-job fetch does too, so a committed job that doesn't resolve in `jobsById`
 * is a sampled (unfetched) one and is NOT counted.
 */
export function countScheduledItems(
	shifts: readonly Shift[],
	jobsById: ReadonlyMap<string, Job>,
	stopsByShiftId: ReadonlyMap<string, readonly ShiftDropoff[]>,
): number {
	let count = 0;
	for (const shift of shifts) {
		for (const id of shift.jobIds) {
			const job = jobsById.get(id);
			if (job != null && !isJobSampled(job)) count++;
		}
		count += stopsByShiftId.get(shift.id)?.length ?? 0;
	}
	return count;
}
